export default __webpack_public_path__ + "static/primis-525805c392a26598c2e246863d4cc9a6.svg";